import { render, staticRenderFns } from "./ProfileConfirm.vue?vue&type=template&id=96af469a"
import script from "./ProfileConfirm.vue?vue&type=script&lang=js"
export * from "./ProfileConfirm.vue?vue&type=script&lang=js"
import style0 from "./ProfileConfirm.vue?vue&type=style&index=0&id=96af469a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports